module.exports = __webpack_public_path__ + "img/f7.6a7778e9.jpg";